<template>
  <div class="flow-view-body">
    <div class="v-form" >

      <div class="flow-view-lf-top">
        <el-button-group>
          <el-button type="primary" icon="el-icon-s-marketing" round @click="dialogVisibleBpmnView=true" title="流程图">流程图</el-button>
          <el-button type="primary" icon="el-icon-printer" round :disabled="!task_id" title="打印" @click="printJs">打印</el-button>
          <el-button v-if="master_id == 37 || master_id == 72 || master_id == 201 || master_id == 202 || master_id == 200" type="primary" icon="el-icon-printer" round :disabled="!task_id" title="下载报销单(A4)" @click="printReimbursement('A4')">下载报销单(A4)</el-button>
          <el-button v-if="master_id == 37 || master_id == 72 || master_id == 201 || master_id == 202 || master_id == 200" type="primary" icon="el-icon-printer" round :disabled="!task_id" title="下载报销单(B5)" @click="printReimbursement('')">下载报销单(B5)</el-button>
          <el-button v-if="master_id == 112" type="primary" icon="el-icon-printer" round :disabled="!task_id" title="下载入库单" @click="printReimbursement()">下载入库单</el-button>
          <el-button type="primary" icon="el-icon-printer" round :disabled="!task_id" title="导出" @click="printWord">导出</el-button>
          <el-button type="primary" icon="el-icon-tickets" round @click="dialogVisibleFlowHistory=true" :disabled="!task_id" title="审批明细">审批明细</el-button>
          <el-button type="primary" icon="el-icon-close" round title="返回" @click="navBack">返回</el-button>
        </el-button-group>
      </div>

      <div id="pdf-box">
        <div class="flow-view-lf-content" id="flow-form-render">
          <v-form-render id="form-render" v-if="form_status" :form-json="formJson" :form-data="formData" :option-data="optionData"  ref="vFormRef" :host_url="host_url">
          </v-form-render>
        </div>
      </div>
    </div>
    <div class="flow-handle">
      <FlowHandle v-if="flow_handle_status" :sheet_id="sheet_id" :task_id="task_id" :node_id="node_id" :masterData="master_data" :step_id="step_id"  :status="status" :master_id="master_id"/>
    </div>

    <el-dialog title="流程图" :visible.sync="dialogVisibleBpmnView" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 500px;overflow-y: auto;">
        <BpmnViewComponents v-if="dialogVisibleBpmnView" :graph_data="graph_data" :task_id="task_id"/>
      </div>
    </el-dialog>

    <el-dialog title="审批明细" :visible.sync="dialogVisibleFlowHistory" :close-on-click-modal="false" width="1000px">
      <div>
        <FlowHistoryComponents v-if="dialogVisibleFlowHistory&&task_id" :where="{task_id:task_id}" />
      </div>
    </el-dialog>
    <select-personnel ref="selectPersonnel" />
    <HouseReductionSelect ref="HouseReductionSelect" />
    <ErpRoomUser ref="ErpRoomUser" />
    <SelectProjectHouse ref="SelectProjectHouse" />
    <select-department ref="selectDepartment" />
    <SelectExpenseAccount ref="SelectExpenseAccount" />
    <InfoExpenseAccount ref="InfoExpenseAccount" />
    <SelectBudgetItemsByMonth ref="SelectBudgetItemsByMonth" />
    <SelectFlow ref="SelectFlow" />
    <SelectWorkClass ref="SelectWorkClass" />
    <SelectMaterial ref="SelectMaterial" />
    <ViewFile ref="ViewFile" />
    <ViewPic ref="ViewPic" />
    <TravelReimbursement ref="TravelReimbursement" />
    <repairs-detail ref="RepairsDetail"/>
  </div>
</template>

<script>
import Http from "./common/Http";
import FlowHandle from "./components/FlowHandle";
import BpmnViewComponents from "./bpmn/BpmnViewComponents";
import FlowHistoryComponents from "./components/FlowHistoryComponents";
import FlowSheet from "./bpmn/lib/FlowSheet";
import flowFromMixins from "./flowFromMixins";
import PrintOne from "../../../assets/lib/PrintOne";
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: "FlowView",
  components: {FlowHistoryComponents, BpmnViewComponents, FlowHandle},
  data(){
    return {
      master_id:0,
      sheet_id:0,
      task_id:0,
      node_id:"",
      step_id:0,
      draft_id:0,
      status:'',
      master_data:{},
      graph_data:{},
      /* 注意：formJson是指表单设计器导出的json，此处演示的formJson只是一个空白表单json！！ */
      formJson: {},
      form_status:false,
      flow_handle_status:true,
      formData: {},
      optionData: {},
      dialogVisibleBpmnView:false,
      dialogVisibleFlowHistory:false,
      dialogVisibleSelectProject:false,
      vFormRef:{},
      host_url:Http.getBaseURL(),
      projectData:{},
      timeValue:'',
      isEditFLowNode:0,
    }
  },
  mixins:[flowFromMixins],
  provide() {
    return {
      __FLOW_PAGE__:this
    }
  },
  created(){
    this.vFormRef=this.$refs.vFormRef
  },
  activated() {
    const that = this;
    that.master_data={}
    that.graph_data={}
    that.formJson={}
    that.formData={}
    that.form_status=false;
    that.flow_handle_status=false;

    that.$nextTick(function () {
      that.master_id=this.$route.query.master_id;
      that.sheet_id=this.$route.query.sheet_id;
      that.task_id=this.$route.query.task_id;
      that.node_id=this.$route.query.node_id;
      that.step_id=this.$route.query.step_id;
      that.draft_id=this.$route.query.draft_id;
      that.timeValue=this.$route.query.timeValue;
      that.batchNumber=this.$route.query.batch_number; // 用于《公区仪表登记审批流程》和《业主仪表登记审批流程》

      if (typeof that.task_id != "undefined") {
        // 重新赋值master_id和sheet_id
        Http.get("flow/FlowInfo/getFlowInfoByTaskId",{
          task_id : that.task_id
        },res=>{
          if(res.code && res.data !== "undefined") {
            // that.master_id = res.data.master_id
            // that.sheet_id = res.data.sheet_id
            that.activatedFunction(that)
          } else {
            that.activatedFunction(that)
          }
        })
      } else {
        that.activatedFunction(that)
      }

    })
  },
  deactivated() {
    // 离开的时候存入缓存
    if (this.timeValue != '') {
      this.$refs.vFormRef.getFormData().then(formData => {
        // Form Validation OK
        sessionStorage.setItem('flow' + this.timeValue, JSON.stringify(formData))
      })
    }
  },
  methods:{
    activatedFunction(that) {
      that.flow_handle_status=true;
      this.getFlowConfig();
      this.task_id&&this.getFormData(this.task_id);

      // 判断是否发起
      if (typeof that.task_id == "undefined"){
        // 常用流程
        let flow_collect = localStorage.getItem("flow_collect");
        if (flow_collect == null) {
          flow_collect = []
        } else {
          flow_collect = JSON.parse(flow_collect)
        }
        flow_collect = _.remove(flow_collect, function(n) {
          return n  != that.master_id;
        });
        // 入队
        flow_collect.push(that.master_id)
        if (flow_collect.length > 30)  {
          // 出队
          flow_collect.shift()
        }
        localStorage.setItem("flow_collect", JSON.stringify(flow_collect));
      }
    },
    printJs(){
      PrintOne("#flow-form-render").extend({
        onStart: function () {
          console.log("开始打印")
        },
        onEnd: function () {
          console.log("打印完成")
        }
      })
    },
    getFlowConfig(){
      const that = this;
      Http.post("flow/FlowHandle/getFlowConfig",{
        master_id:that.master_id,
        sheet_id : that.sheet_id
      },res=>{
        if(res.code) {
          that.master_data=res.data;
          that.graph_data=JSON.parse(res.data.graph_data)

          if(!that.node_id){
            let fs=new FlowSheet(that.graph_data)
            that.node_id=fs.getStart().id
            fs=undefined;
          }
          if (this.task_id > 0) {
            that.getFormData(this.task_id)
          } else {
            that.formDetail(res.data.flow_master.form_id)
          }
        }
      })
    },
    formDetail(form_id=15){
      const that = this;
      Http.get("flow/FlowForm/formDetail",{
        form_id:form_id,
      },res=>{
        if(res.code&&res.data) {
          that.form_status=true;
          that.$nextTick(function () {
            that.$refs.vFormRef.setGraphData(that.graph_data);
            that.$refs.vFormRef.setFormJson(res.data.form_json)
            if (that.draft_id > 0) {
              that.$nextTick(function () {
                that.getDraft()
              })
            } else {
              if (typeof that.task_id == "undefined" || that.task_id == '') {
                // 判断缓存值是否存在，存在则渲染
                let cache = sessionStorage.getItem('flow'+ this.timeValue);
                if (cache) {
                  that.$refs.vFormRef.setFormData(JSON.parse(cache));
                }
              }
            }
            that.$nextTick(function () {
              that.getQueryData()
              that.onDisabled()
            })

          })
        }
      })
    },
    // 获取表单提交的数据
    getFormData(task_id=5){
      const that = this
      Http.get("flow/FlowForm/getFormData",{
        task_id:task_id,
      },res=>{
        if(res.code) {
          that.form_status=false;
          that.status = res.data.status;
          that.$nextTick(function () {
            that.formData = res.data
            that.form_status=true;
            that.$nextTick(function () {
              that.$refs.vFormRef.setGraphData(that.graph_data);
              that.$refs.vFormRef.setFormJson(res.data.form_json);
              that.$nextTick(function () {
                // 撤回的审批单可以再次编辑提交 10:撤回  11：退回重填
                if (res.data.status != 10 && res.data.status != 11) {
                  that.subFormShow()
                  that.$refs.vFormRef.disableForm();
                }
                that.getQueryData()
                that.onDisabled()

                // // 判断当前节点能否修改审批人
                // let node_edit = false;
                // for(var i = 0; i < that.graph_data.nodes.length; i++) {
                //   let item = that.graph_data.nodes[i]
                //   let node = that.formData[item.id];
                //   if (item.type == 'user' && node != undefined) {
                //     node = node[node.length -1];
                //     // 判断是否当前的处理节点
                //     if (node.is_handle == 0 && node.posted == 1 && node.is_push == 1) {
                //       // 后期改为 edit_node
                //       if (typeof item.properties != "undefined" && item.properties.edit_node) {
                //         node_edit = true
                //       }
                //     }
                //     if (node_edit) {
                //       that.$refs.vFormRef.getWidgetRef(item.id).setDisabled(false)
                //     }
                //   }
                // }
                // if (node_edit && typeof that.$refs.vFormRef.getWidgetRef('is_edit_node') != "undefined") {
                //   that.$refs.vFormRef.getWidgetRef('is_edit_node').setValue(1)
                // }

              })
            })
          })

        }
      })
    },
    // 获取vform数据
    getVFormRenderData(callback) {
      let that = this
      this.$refs.vFormRef.getFormData().then(formData => {
        callback(formData)
      }).catch(error => {
        this.$message.error(error)
      })
    },
    submitForm() {
      this.$refs.vFormRef.getFormData().then(formData => {
        // Form Validation OK
        alert( JSON.stringify(formData) )
      }).catch(error => {
        // Form Validation failed
        this.$message.error(error)
      })
    },
    getDraft() {
      let that = this
      Http.get("flow/FlowForm/getDraftDetail",{
        draft_id:that.draft_id,
      },res=>{
        if(res.code) {
          that.$nextTick(function () {
            console.info(that.$refs.vFormRef)
            that.$refs.vFormRef.setFormData(res.data.vform_data);
          });
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 渲染时，把流程图放到vform渲染
    importSheetToVForm(sheet_id) {
      Http.get("flow/FlowSheet/get",{
        id:sheet_id,
      },res=>{
        if(res.code) {
          // 把拿到的数据放到vform里面
          let graph_data=JSON.parse(res.data.graph_data);

          this.$refs.vFormRef.setGraphData(graph_data);
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onDisabled(){
      const that=this;
      let fs=new FlowSheet(that.graph_data)
      let field_not_disable_arr=[];
      let field_hide_arr=[];
      let node=fs.getProperties("id",that.node_id);
      if(node&&node.form_fields){
        let field_keys=Object.keys(node.form_fields)
        field_keys.map(ret=>{
          if(node.form_fields[ret]!==undefined){
            node.form_fields[ret].write&&field_not_disable_arr.push(ret);
            !node.form_fields[ret].read&&field_hide_arr.push(ret);
          }
        })
      }
      if(node&&node.form_fields){
        field_not_disable_arr.length&&that.$refs.vFormRef.disableForm();
        that.$nextTick(()=>{
          field_not_disable_arr.length&&that.$refs.vFormRef.setWidgetDisable(field_not_disable_arr,false)
          field_hide_arr.length&&that.$refs.vFormRef.setWidgetHidden(field_hide_arr,true)
        })
      }
    },
    // 获取子表
    subFormShow() {
      //子表单列表
      let list = this.$refs.vFormRef.subFormRefList
      for(let key in list) {
        // 判断渲染的html组件是否存在
        if (typeof list[key].getWidgetRef(key + '_html_json') != "undefined") {
          list[key].setHidden(true)
          list[key].getWidgetRef(key + '_html_json').setHidden(false)
        }
      }
    },
    navBack(){
      ERP.navigateBack()
    },
    getPdf(){
      let that = this
      const scrollTop = document.getElementById('form-render').scrollTop
      // 加上这几行代码就好了  render-form
      window.pageYoffset = 0
      document.getElementById('form-render').scrollTop = 0
      document.body.scrollTop = 0
      var title = this.formData.serial_number
      html2Canvas(document.getElementById('form-render'), {
        allowTaint: true,
        height: document.getElementById('form-render').scrollHeight,
        windowHeight: document.getElementById('form-render').scrollHeight,
      }).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)

        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
        // let base64 = PDF.output('dataurl');
        // let blob = that.base64ToBlob(base64, 'pdf')
        // that.downloadFile(title,blob)

      })
    },
    // * desc: base64对象转blob文件对象
// * @param urlData  ：数据的base64对象
// * @param type  ：类型
// * @returns {Blob}：Blob文件对象
    base64ToBlob(urlData, type) {
      const arr = urlData.split(',')
      const array = arr[0].match(/:(.*?);/)
      const mime = (array && array.length > 1 ? array[1] : type) || type
      // 去掉url的头，并转化为byte
      const bytes = window.atob(arr[1])
      // 处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length)
      // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
      const ia = new Uint8Array(ab)
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], {
        type: mime
      })
    },

    downloadFile(reportName, byte) {
      const link = document.createElement('a') // 创建a标签
      const blob = new Blob([byte], {
        type: 'application/pdf;charset=utf-8',
      }) // response就是接口返回的文件流
      const objectUrl = URL.createObjectURL(blob)
      link.href = objectUrl
      link.download = reportName
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl)
    },

    printReimbursement(type) {
      let that = this
      if (that.master_id == 72)
      {
        Http.post("flow/FlowForm/printReimbursement72?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      else if(that.master_id == 112)
      {
        Http.post("flow/FlowForm/printWarehouse?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      else if (that.master_id == 201) {
        // 业务接待报销
        Http.post("flow/FlowForm/printReimbursement201?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      else if (that.master_id == 202) {
        // 业务接待报销
        Http.post("flow/FlowForm/printReimbursement202?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      else if (that.master_id == 200) {
        // 业务接待报销
        Http.post("flow/FlowForm/printReimbursement200?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      else
      {
        Http.post("flow/FlowForm/printReimbursement?type=" + type,{
          form_data : that.formData, type : type
        },res=>{
          if(res.code) {
            window.open(res.data);
            // window.location.href = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }

    },
    printWord() {
      let that = this
      this.getPdf()

      // if (that.master_id == 14 || that.master_id == 20) {
      //   Http.post("flow/PrintFlow/printWord",{
      //     form_data : that.formData,
      //     master_id : that.master_id,
      //   },res=>{
      //     if(res.code) {
      //       window.open(res.data);
      //       // window.location.href = res.data
      //     } else {
      //       this.$message.error(res.msg)
      //     }
      //   })
      // } else {
      //   this.getPdf()
      // }
    },
    // 渲染外部参数传过来的值
    getQueryData() {
      let that = this
      // 用于《公区仪表登记审批流程》和《业主仪表登记审批流程》
      if (that.batchNumber) {
        that.$refs.vFormRef.getWidgetRef('batch_number').setValue(that.batchNumber)
      }
    }
  }
}
</script>
<style type="text/css">
/*.el-radio__input.is-disabled+span.el-radio__label {*/
/*  color: #000000 !important;*/
/*}*/
/*.el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {*/
/*  background-color: #409EFF;*/
/*}*/


.el-radio__input.is-disabled+.el-radio__label {
  color: #000000 !important;
}

.el-radio__input.is-disabled.is-checked+.el-radio__label {
  color: #1890ff !important;
}
.el-radio__input.is-disabled.is-checked .el-radio__inner::after{
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.el-checkbox__input.is-disabled.is-checked.el-radio__inner {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}

.el-checkbox__input.is-disabled + .el-checkbox__label {
  color: #000000 !important;
}

.el-checkbox__input.is-disabled.is-checked + .el-checkbox__label {
  color: #1890ff !important;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}



</style>

<style lang="scss" scoped>
@import "common";
.flow-view-body{
  //width: calc( 100vw - 160px );
  height: calc( 100vh - 100px );
  display: flex;
  flex-direction: row;
  position: relative;
  .v-form{
    //width: 80%;
    //width: calc( 100vw - 160px - 310px );
    height: calc( 100vh - 100px );
    background-color: #e3e3e3;

    .flow-view-lf-top{
      background: #fff;
      padding: 10px;
      border-right: 1px solid #e5e5e5;
    }
    .flow-view-lf-content{
      overflow-y: scroll;
      height: calc( 100vh - 140px );
      padding: 5px 5px;
      background-color: white;
      border-right: 1px solid #e5e5e5;
    }
    .flow-view-lf-content::-webkit-scrollbar{
      width: 10px;
    }
    .flow-view-lf-content::-webkit-scrollbar-thumb {
      background: #B6B6B6;
    }
    .flow-view-lf-content::-webkit-scrollbar-track {
      background: #E3E3E3;
    }
  }
  .flow-handle{
    //width: 330px;
    //width: 400px;
  }
  /deep/ .el-input__inner {
    color: #000000;
  }
  /deep/ .el-textarea__inner {
    color: #000000;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowView.vue